module.exports = __webpack_public_path__ + "img/example.d11d84ee.png";